import { useEffect, useRef } from "react";
import { animate } from "framer-motion";

// Animated number that tweens between values with an expo-out ease.
export const CountUp = ({ value, format, className = "", testid, duration = 1.1 }) => {
  const ref = useRef(null);
  const prev = useRef(0);

  useEffect(() => {
    const target = Number.isFinite(value) ? value : 0;
    const controls = animate(prev.current, target, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => {
        if (ref.current) ref.current.textContent = format(v);
      },
    });
    prev.current = target;
    return () => controls.stop();
  }, [value, duration, format]);

  return (
    <span ref={ref} className={className} data-testid={testid}>
      {format(Number.isFinite(value) ? value : 0)}
    </span>
  );
};
